import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty, find } from 'lodash';
import { fetchUserEntitlements } from '../app-main/actions/entitlements';
import { PageSpinner } from 'shared-components/decorators/spinner';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class SignupSuccessModal extends Component {
  constructor (props) {
    super(props);
  }

  componentDidMount () {
    const { dispatch, SSOid, accessToken } = this.props;

    dispatch(fetchUserEntitlements(SSOid, accessToken));
  }

  componentDidUpdate (prevProps) {
    const { params = {}, entitlements } = this.props;
    const referralId = params.referralId;
    const guestReferralEntitlement = find(get(entitlements, 'referralData.attachments', []), { class: 'GUEST_REFERRAL' });
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();

    // if the user doesn't have any entitlements attached go to /claim
    if (prevProps.entitlements.isFetching && !entitlements.isFetching) {
      if (isEmpty(guestReferralEntitlement)) {
        window.location.href = `${urlPrefix ? `/${urlPrefix}` : ''}/claim/${referralId}`;
      }
    }
  }

  render () {
    const { entitlements } = this.props;
    const guestReferralEntitlement = find(get(entitlements, 'referralData.attachments', []), { class: 'GUEST_REFERRAL' });
    const entitlementsError = entitlements.error;
    const discountValue = find(get(guestReferralEntitlement, 'entitlement.actions'), { type: 'GUEST_REFERRAL_DISCOUNT' });

    if (!isEmpty(guestReferralEntitlement) && !entitlementsError) {
      return (
        <div className="container-fluid">
          <div className="SignupSuccessModalContainer">
            <div className="row margin-xl-top">
              <div className="col-xs-12">
                <img className="success-img img-responsive" src="https://assets.peerspace.com/referral-success.svg?v=rb" />
              </div>
              <div className="col-xs-12 text-center margin-xl-top">
                <h2>
                  <FormattedMessage
                    id='referrals.signup_success_modal.got_value'
                    defaultMessage='You just got {value}'
                    values={{
                      value: (
                        <FormattedNumber
                          value={discountValue.value}
                          currency='USD'
                          style='currency'
                          minimumFractionDigits={0 === discountValue.value % 1 ? 0 : 2}
                          maximumFractionDigits={0 === discountValue.value % 1 ? 0 : 2}
                        />
                      )
                    }}
                  />
                </h2>
                <p className="margin-xl-bottom">
                  <FormattedMessage
                    id='referrals.signup_success_modal.automatically_apply'
                    defaultMessage='Your discount will be automatically applied to your first booking of {value} or more.'
                    values={{
                      value: (
                        <FormattedNumber
                          value={discountValue.minimum_booking_subtotal}
                          currency='USD'
                          style='currency'
                          minimumFractionDigits={0 === discountValue.minimum_booking_subtotal % 1 ? 0 : 2}
                          maximumFractionDigits={0 === discountValue.minimum_booking_subtotal % 1 ? 0 : 2}
                        />
                      )
                    }}
                  />
                </p>
                <a href="/" className="btn btn-primary btn-block">
                  <FormattedMessage id='referrals.signup_success_modal.explore_spaces' defaultMessage='Explore Spaces' />
                </a>
                <p className="margin-xl-top text-small text-gray-600">
                  <FormattedMessage id='referrals.signup_success_modal.only_us' defaultMessage='Offer only valid on bookings in the United States.' />
                </p>
                <div className="flex center margin-xl-top iphone-container">
                  <img src="https://assets.peerspace.com/iphone.svg?v=rb" />
                  <div className="margin-lg-left">
                    <FormattedMessage id='referrals.signup_success_modal.download_ios_app' defaultMessage='Download the iOS app for the best experience.' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="container-fluid flex center middle">
        <PageSpinner additionalStyle="gray" />
      </div>
    );
  }
}

SignupSuccessModal.propTypes = {
  dispatch: PropTypes.func,
  SSOid: PropTypes.string,
  accessToken: PropTypes.string,
  entitlements: PropTypes.object,
  params: PropTypes.object
};

function mapStateToProps (state) {
  const { auth, nav, profile, nux, entitlements } = state;
  const { accessToken } = auth;
  const { SSOid } = profile;

  return {
    auth,
    nav,
    profile,
    SSOid,
    accessToken,
    nux,
    entitlements
  };
}

export default connect(mapStateToProps)(SignupSuccessModal);
